function SignalSelectionList() {
    /// <summary>
    /// This object provides js functions for the SignalSelection Lists <br/>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 28.6.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 28.6.2017                                            *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
  
}
SignalSelectionList.prototype = new window.vcTemplate();
SignalSelectionList.prototype.init = function () {
    /// <summary>
    /// This function inits the signal selection menu 
    /// </summary>
    var me = this;
    try {
        if (me.error) {return false;}

        me.showInfo("", "", false);

        me.visual.find('.vc-list').height(me.visual.height()-2);
        me.visual.find("#div-signal-filter").vcFilter({ callback: function () { me.filter(); } });

        ////init the filter events
        me.loadItems(-1);

        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }

};
SignalSelectionList.prototype.loadFirstInList = function(id) {
    /// <summary>
    /// If implemented this function loads the first item in the selection list
    /// </summary>
    var me = this;
    if (id !== -0x1) {
        me.visual.find("#ul-lst-signals .vc-list-item[data-id='" +id +"']").trigger("click");

    } else {
        me.visual.find("#ul-lst-signals .vc-list-item:first").trigger("click");
    }
};
SignalSelectionList.prototype.addSpecificClickHandler = function (id) {
    /// <summary>
    /// This function inits the assigment specific icons if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        me.visual.find("#ul-lst-signals .vc-list-item").off("click").on("click",function() {me.loadSingleItem($(this));});
        me.visual.find("#ul-lst-signals .vc-list-item .add-image").off("click").on("click", function (event) { me.addImage(event); });
        me.loadFirstInList(id);
    } catch (ex) {
        me.writeError('signalSelectionList.addSpecificClickHandler', ex);

    }

};
SignalSelectionList.prototype.loadSingleItem = function (element) {
    /// <summary>
    /// This function loads the current element widget 
    /// </summary>
    ///<param name='element'> the element to the widget for has to contain a data-id </param>   
    var me = this;
    try {
        if (me.error) {
            return;
        }
        me.visual.find(".vc-list-item").removeClass("selected");
        element.addClass("selected");
        me.vcVisual.addVisualContentByName("div", "VISUAL_GALLERY_SINGLESIGNAL_DOCUMENTATION", "Signals", window.getCurrentTimestamp(), 600, 1200, "", JSON.stringify({ "bsaid": element.data("id") }), 1);
    } catch (ex) {
        me.writeError('signalSelectionList.loadSingleItem', ex);
        }

};
SignalSelectionList.prototype.addImage = function (event) {
    /// <summary>
    /// This function adds the functionality for the plus button to add a new image
    /// </summary>
    ///<param name='event'>the event that called the function </param>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        event.stopPropagation();
        me.visual.find(".vc-list-item").removeClass("selected");
        $(event.currentTarget).parent(".vc-list-item").addClass("selected");
        me.vcVisual.addVisualContentByName("div", "WIDGET_GALLERY_UPLOAD_SIGNAL_INSTALL", "VCSignals", window.getCurrentTimestamp(), 600, 1300, JSON.stringify({ mediaCategory: "SIGNAL" }), JSON.stringify({ "mediaid": -1, "signalid": $(event.currentTarget).parent().data("id") }), 1);
    } catch (ex) {
        me.writeError('signalSelectionList.addImage', ex);

    }

};
SignalSelectionList.prototype.addAssignmentItemSpecifics = function(row) {
    /// <summary>
    /// This function inits the assigment specific html if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    var sTmp = "";
    try {
        if (me.error) {
            return false;
        }
        if (row.has_standard_pic === true) {
            sTmp +=
                "<i class='fa fa-image icon-color-ok' style='float:left; margin-right:5px; margin-top:2px;'></i>";

        } else {
            sTmp +=
                "<i class='fa fa-image icon-color-error' style='float:left; margin-right:5px; margin-top:2px;'></i>";
        }

        return sTmp;
    } catch (ex) {
        me.writeError('signalSelectinList.addAssignmentmentItemSpecifics', ex);
        return false;
    }
};
SignalSelectionList.prototype.loadItems = function (id) {
    /// <summary>
    /// This function loads all entries for the selected item and fills the sortable lists 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false;}
        me.assID = id;
        me.visual.find("#ul-lst-signals").html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, me.parameter, '', me.deviceType, me.langid, "", function (result) { me.setResultItems(result,id); });

        return true;
    } catch (ex) {
        me.writeError('SignalSelectionList.loadItems', ex);
        return false;
    }

};
SignalSelectionList.prototype.setResultItems = function (result,id) {
    /// <summary>
    /// This function sets the entries got from the webservice request and fills the list
    /// </summary>
    var sTmp = "";
    var me = this;
    try {
        if (me.error) {
            return false;
        }
            if (result === null) {
                me.showMessage(me.resources.err_saveData, true);
                return false;
            }
        if (result.rows === null) {
            me.showMessage(me.resources.noEntriesExist, false);
            me.visual.find("#div-signal-list").hide();
            return false;
        }

        me.visual.find("#ul-lst-signals").html("");
        for (var i = 0; i < result.rows.length; i++) {
            sTmp += "<li class='vc-list-item ";
            if (i % 2 === 0) {
                sTmp += " alt ";
            }
            if (result.rows[i].active === false) {
                sTmp += " inactive";
            }

            sTmp += "' data-id='" + result.rows[i].id + "'>";
            sTmp += me.addAssignmentItemSpecifics(result.rows[i]);

            sTmp += "<div class='list-main-text' style='float:left;" + "'>" + result.rows[i].name;
            if (result.rows[i].assigned_documents_counter > 0) {
                sTmp += " (" +
                    result.rows[i].assigned_documents_counter +
                    "<i class='fa fa-copy icon-color-info'></i>)";
            }
            sTmp += "</div> ";


            sTmp += "<i class='fa fa-plus-square icon-color-info add-image fa-2x' style='float:right'></i>";
            sTmp += "</li>";

        }
        me.visual.find("#ul-lst-signals").html(sTmp);
        me.addSpecificClickHandler(id);

        // init the refilled sortable source and target lists
        me.filter();
    } catch (ex) {
        me.writeError('SignalSelectionList.setResultItems', ex);

    }
    return true;
};
SignalSelectionList.prototype.filter = function() {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        //hide all
        me.visual.find(".vc-list-table .vc-list-item").removeClass("found").data("counter", 0).hide();

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "found");

        me.visual.find(".vc-list-table .vc-list-item.found").show();
        me.visual.find(".vc-list-table .vc-list-item").removeClass("alt");
        me.visual.find(".vc-list-table .vc-list-item.found:even").addClass("alt");


        return true;
    } catch (ex) {
        me.writeError('HighResList.filter', ex);
        return false;
    }
};
SignalSelectionList.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#div-signal-list').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex);
        return false;
    }
};
SignalSelectionList.prototype.doEvent = function(event) {
    /// <summary>
    /// This function  handles incoming messages 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;

        }
        switch (event.msg) {
            //view Event
        case me.VCMQ_toggle_list_update_message:
            me.loadItems(event.values.id);
            break;
        default:
            break;

        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};